export default "__VITE_ASSET__BZBLPxsM__"